import React from 'react'
import {
    LightbulbIcon,
    ChartLineUpIcon,
    LinkIcon,
    StackIcon,
    PathIcon,
    CurrencyCircleDollarIcon,
} from '@phosphor-icons/react'
import { ScoopText, ScoopColumn, ScoopRow, ScoopCenter } from '../../../ui'
import styles from './HelpBotEmptyState.module.scss'

const SUGGESTIONS = [
    {
        icon: LightbulbIcon,
        label: 'What can I do with Scoop?',
        query: 'What can I do with Scoop? Give me an overview of the main features.',
    },
    {
        icon: ChartLineUpIcon,
        label: 'How do I set up churn analysis with my HubSpot data?',
        query: 'How do I set up churn analysis with my HubSpot data?',
    },
    {
        icon: LinkIcon,
        label: 'Walk me through connecting Close CRM',
        query: 'Walk me through connecting Close CRM to Scoop',
    },
    {
        icon: StackIcon,
        label: 'How do I connect and analyze data from multiple sources?',
        query: 'How do I connect and analyze data from multiple sources?',
    },
    {
        icon: PathIcon,
        label: "How do I track a customer's full journey across my tools?",
        query: "How do I track a customer's full journey across my tools?",
    },
    {
        icon: CurrencyCircleDollarIcon,
        label: 'How do I measure marketing ROI with my Google Ads data?',
        query: 'How do I measure marketing ROI with my Google Ads data?',
    },
]

export const HelpBotEmptyState = ({ onSuggestionClick }) => {
    return (
        <ScoopColumn gap={16} className={styles.container}>
            <ScoopColumn gap={8}>
                <ScoopText className={styles.greeting}>Welcome to Scoop!</ScoopText>
                <ScoopText className={styles.description}>
                    I'm here to help you get the most out of your data. What would you like to know?
                </ScoopText>
            </ScoopColumn>

            <div className={styles.suggestionsGrid}>
                {SUGGESTIONS.map((suggestion, index) => {
                    const IconComponent = suggestion.icon
                    return (
                        <button
                            key={index}
                            className={styles.suggestionCard}
                            onClick={() => onSuggestionClick(suggestion.query)}
                        >
                            <ScoopRow align="center" gap={10}>
                                <ScoopCenter className={styles.iconWrapper}>
                                    <IconComponent size={14} weight="bold" />
                                </ScoopCenter>
                                <ScoopText className={styles.suggestionText}>
                                    {suggestion.label}
                                </ScoopText>
                            </ScoopRow>
                        </button>
                    )
                })}
            </div>
        </ScoopColumn>
    )
}
